<div class="sidebar-wrapper d-flex flex-column h-100">
    <div class="client-sidebar text-primary-green border-0 h-100  rounded-lg d-flex flex-column shadow p-2 glassy-sidebar">
        <button
          class="btn btn-close d-lg-none align-self-end m-2 d-none"
          @click="$emit('close')"
          aria-label="Close sidebar"></button>
        <div class="sidebar-brand text-center mt-3">
          <a class="d-none mt-3" id="sidebar_toggle">
            <img :src="$clientLogo" alt="Logo" class="logo-img" width="190px">
          </a>
          <hr class="d-none text-white mx-2 mt-2"/>
        </div>

        <div class="sidebar-content flex-grow-1 scrollable-container">
          <div class="d-flex justify-content-center  h-100">
            <!-- Workflows Dynamic Sidebar -->
            <ul class="nav flex-column h-100">
              <!-- User Management Sidebar (Hardcoded) -->
              <template v-if="should_show_template">
                <nav class="entity-sidebar p-5">
                  <ul class="nav flex-column">
                    <li>
                      <router-link to="/company_management" @click="set_hardcoded_active('company_management')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('company_management') }">
                        <i class="bi bi-folder-fill fs-5"></i> Clients
                      </router-link>
                    </li>
                    
                    <li>
                      <router-link to="/user_management" @click="set_hardcoded_active('user_management')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('user_management') }">
                        <i class="fas fa-users fs-5"></i> Users
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/action_management" @click="set_hardcoded_active('action_management')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('action_management') }">
                        <i class="fa-solid fa-screwdriver-wrench fs-5"></i> Actions
                      </router-link>
                    </li>
                     <li>
                      <router-link to="/creating_a_policy" @click="set_hardcoded_active('creating_a_policy')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('creating_a_policy') }">
                        <i class="fa fa-key fs-5"></i> Policy
                      </router-link>
                    </li>
                    
                    <!-- System Configuration -->
                    <li class="">
                      <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#systemConfigMenu" role="button" aria-expanded="false" aria-controls="systemConfigMenu">
                        <span><i class='fa-solid fa-gear me-1 fs-4'></i> System Configuration </span>
                        <i class="bx bxs-chevrons-down rotate-icon"></i>
                      </a>
                      <ul class="collapse list-unstyled ps-3" id="systemConfigMenu">
                        <li>
                        <router-link to="/manage_entity_type" @click="set_hardcoded_active('manage_entity_type')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('manage_entity_type') }">
                            <i class='bx bxs-chevrons-right'></i> Entity Type
                        </router-link>
                        </li>
                        <li v-if="is_super_user">
                          <router-link to="/verification_services_configurations" @click="set_hardcoded_active('verification_services_configurations')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('verification_services_configurations') }">
                            <i class='bx bxs-chevrons-right'></i>Verification Services
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/form_management" @click="set_hardcoded_active('form_management')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('form_management') }">
                            <i class='bx bxs-chevrons-right'></i>Manage Forms
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/manage_questions" @click="set_hardcoded_active('manage_questions')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('manage_questions') }">
                            <i class='bx bxs-chevrons-right'></i> Manage Questions
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/view_template" @click="set_hardcoded_active('view_template')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('view_template') }">
                            <i class='bx bxs-chevrons-right'></i>Manage Templates
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/signing_workflow" @click="set_hardcoded_active('signing_workflow')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('signing_workflow') }">
                            <i class='bx bxs-chevrons-right'></i>Manage Signing
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/status_management" @click="set_hardcoded_active('status_management')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('status_management') }">
                            <i class='bx bxs-chevrons-right'></i>Manage Statuses
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/create_enquiry_form" @click="set_hardcoded_active('create_enquiry_form')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('create_enquiry_form') }">
                            <i class='bx bxs-chevrons-right '></i>Enquiries
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/services" @click="set_hardcoded_active('services')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('services') }">
                            <i class='bx bxs-chevrons-right'></i>Services
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/package_services" @click="set_hardcoded_active('package_services')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('package_services') }">
                            <i class='bx bxs-chevrons-right'></i>Packages
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/create_enquiry_stages" @click="set_hardcoded_active('create_enquiry_stages')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('create_enquiry_stages') }">
                            <i class='bx bxs-chevrons-right'></i>CRM Configurations
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/manage_risks" @click="set_hardcoded_active('manage_risks')" class="nav-item nav-link text-decoration-none" :class="{ active: is_hardcoded_active('manage_risks') }">
                            <i class='bx bxs-chevrons-right'></i>Manage Risks
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div class="sidebar-footer p-3 border-top border-dark mt-5">
                        <div class="d-flex align-items-center mb-3">
                          <div class="avatar-circle me-2 text-capitalize">
                            {{ (currently_logged_in || '').slice(0, 1) }}
                          </div>

                          <div class="user-info">
                            <p class="m-0 text-dark fw-bold text-xxs">{{ currently_logged_in }}</p>
                            <small class="text-dark text-xxs">{{ role }}</small>
                          </div>
                        </div>
                        <a href="/" class=" ms-2 nav-link nav-item p-0 text-muted text-xxs">
                          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
                        </a>
                      </div>
                </nav>
              </template>
              <!-- Entity Sidebar -->
              <div v-else-if="['/view_user_trust_form', '/view_all_user_forms','/entity_overview', '/requested_information_update', '/unresolved_request', '/resolved_requests', '/enquiry_chat', '/entity_application_overview', '/application_overview_details', '/auto_verification_overview', '/entity_overview', '/view_contracts', '/entity_risk_assessment', '/answer_risk_assessment', '/lead_questionnaire', '/lead_questionnaire_form', '/entity_enquiry_management', '/proof_of_payments'].includes($route.path)">
                <a class="mt-3" id="sidebar_toggle">
                  <img :src="$clientLogo" alt="Logo" class="logo-img" width="190px">
                </a>
                <hr class="text-white mx-2 mt-2"/>
                <nav v-if="sorted_menu_items?.length" class="entity-sidebar">
                  <ul class="nav flex-column">
                    <template v-for="component in sorted_menu_items" :key="component.id">
                      <li v-for="sub in component.sub_components" :key="sub.id">
                        <!-- If no child components -->
                        <router-link
                          v-if="!sub.child_components?.length"
                          :to="build_route_location(sub, component)"
                          @click="set_active_item(sub, 'sub')"
                          class="nav-item nav-link text-decoration-none"
                          :class="{ active: is_active(sub, 'sub') }"
                        >
                          <i v-if="sub.icon_class" :class="sub.icon_class" class="me-1 fs-4"></i> <span class="sidebar-text" :title="sub.name">{{ sub.name }}</span>
                        </router-link>

                        <!-- If has child components -->
                        <a
                          v-else
                          class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center"
                          data-bs-toggle="collapse"
                          :href="'#collapse-' + sub.id"
                          role="button"
                          aria-expanded="false"
                          :aria-controls="'#collapse-' + sub.id"
                        >
                          <span>{{ sub.name }}</span>
                          <i class="bx bxs-chevrons-down rotate-icon"></i>
                        </a>

                        <!-- Nested child components -->
                        <ul
                          v-if="sub.child_components?.length"
                          class="ms-4 collapse list-unstyled ps-3"
                          :id="'collapse-' + sub.id"
                        >
                          <li v-for="child in sub.child_components" :key="child.id">
                            <router-link
                              :to="build_route_location(child, sub)"
                              @click="set_active_item(child, 'child')"
                              class="nav-item nav-link text-decoration-none d-flex align-items-center"
                              :class="{ active: is_active(child, 'child') }"
                            >
                              <i v-if="child.icon_class" :class="child.icon_class" class="me-1 fs-4"></i>
                              {{ child.name }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <div class="sidebar-footer p-3 border-top border-dark mt-5">
                        <div class="d-flex align-items-center mb-3">
                          <div class="avatar-circle me-2 text-capitalize">
                            {{ (entity_name || '').slice(0, 1) }}
                          </div>

                          <div class="user-info">
                            <p class="m-0 text-dark fw-bold text-xxs">{{ entity_name }}</p>
                            <small class="text-dark text-xxs">{{ entity_type_name }}</small>
                          </div>
                        </div>
                        <a href="/" class=" ms-2 nav-link p-0 text-muted text-xxs">
                          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
                        </a>
                      </div>

                    </template>
                  </ul>
                </nav>
              </div>
              <!-- Main Sidebar -->
              <div v-else>
                <template v-if="sorted_menu_items?.length">
                  <a class="mt-3" id="sidebar_toggle">
                    <img :src="$clientLogo" alt="Logo" class="logo-img" width="190px">
                  </a>
                  <hr class="text-white mx-2 mt-2"/>
                  <nav class="entity-sidebar">
                    <ul class="nav flex-column" v-for="component in sorted_menu_items" :key="component.id">
                      <li v-for="sub in component.sub_components" :key="sub.id">
                        <!-- Single router-link for items without children -->
                        <router-link
                          v-if="!sub.child_components?.length"
                          :to="build_route_location(sub, component)"
                          @click="set_active_item(sub, 'sub')"
                          class="nav-item nav-link text-decoration-none"
                          :class="{ active: is_active(sub, 'sub') }">
                          <i v-if="sub.icon_class" :class="sub.icon_class" class="me-1 fs-4"></i> <span class="sidebar-text" :title="sub.name">{{ sub.name }}</span>
                        </router-link>

                        <!-- Collapsible section for items with children -->
                        <template v-else>
                          <a
                            class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center"
                            data-bs-toggle="collapse"
                            :href="'#collapse-' + sub.id"
                            role="button"
                            aria-expanded="false"
                            :aria-controls="'#collapse-' + sub.id"
                          >
                            <span><i v-if="sub.icon_class" :class="sub.icon_class" class="me-1 fs-4"></i>
                              <span class="sidebar-text" :title="sub.name">{{ sub.name }}</span>
                            </span>
                            <i class="bx bxs-chevrons-down rotate-icon"></i>
                          </a>
                          <ul
                            class="ms-4 collapse list-unstyled"
                            :id="'collapse-' + sub.id">
                            <li v-for="child in sub.child_components" :key="child.id">
                              <router-link
                                :to="build_route_location(child, sub, true)"
                                @click="set_active_item(child, 'child')"
                                class="nav-item nav-link text-decoration-none"
                                :class="{ active: is_active(child, 'child') }">
                                <i class='bx bxs-chevrons-right text-primary'></i>
                                <span class="sidebar-text" :title="child.name">{{ child.name }}</span>
                              </router-link>
                            </li>
                          </ul>
                        </template>
                      </li>
                      <div class="sidebar-footer p-3 border-top border-dark mt-5">
                        <div class="d-flex align-items-center mb-3">
                          <div class="avatar-circle me-2 text-capitalize">
                            {{ (currently_logged_in || '').slice(0, 1) }}
                          </div>

                          <div class="user-info">
                            <p class="m-0 text-dark fw-bold text-xxs">{{ currently_logged_in }}</p>
                            <small class="text-dark text-xxs">{{ role }}</small>
                          </div>
                        </div>
                        <a href="/" class=" ms-2 nav-link p-0 text-muted text-xxs">
                          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
                        </a>
                      </div>
                    </ul>
                  </nav>

                </template>
              </div>
            </ul>
        </div>
    </div>
  </div>
</div>